import RefreshTable from "./refreshTable.component";

export default RefreshTable;
